import React from 'react';
import './RideCancelledPage.css';
import { useLanguage } from './i18n/LanguageContext';

const RideCancelledPage = ({ ride, onBack, variant = 'page' }) => {
  const { t } = useLanguage();
  if (!ride) {
    return null;
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (e) {
      return dateString;
    }
  };

  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (e) {
      return dateString;
    }
  };

  return (
    <div className={`ride-cancelled-page${variant === 'panel' ? ' is-panel' : ''}`}>
      {/* Back Button */}
      <button className="cancelled-back-button" onClick={onBack}>
        <img
          src={process.env.PUBLIC_URL + '/images/back_button.svg'}
          alt="Back"
        />
      </button>

      {/* Cancellation Status */}
      <div className="cancellation-status">
        <div className="cancellation-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h1 className="cancellation-title">{t('Ride cancelled')}</h1>
      </div>

      <div className="cancelled-ride-card">
        <div className="ride-detail-row">
          <div className="detail-dot pickup-dot"></div>
          <div className="ride-detail-content">
            <span className="detail-label">{t('PICKUP POINT')}</span>
            <span className="detail-value">{ride.startLocation || 'Pickup Location'}</span>
          </div>
        </div>
        <div className="ride-detail-row">
          <div className="detail-dot drop-dot"></div>
          <div className="ride-detail-content">
            <span className="detail-label">{t('DROP DESTINATION')}</span>
            <span className="detail-value">{ride.endLocation || 'Drop Location'}</span>
          </div>
        </div>
        <div className="cancelled-date-time">
          <span className="date-text">Date : {formatDate(ride.carRequestTime || ride.createdAt || ride.bookingDate)}</span>
          <span className="time-text">Time : {formatTime(ride.carRequestTime || ride.createdAt || ride.bookingDate || ride.pickupTime)}</span>
        </div>
      </div>
    </div>
  );
};

export default RideCancelledPage;
